<template>
<div class="day-picker-wrap">
  <div class="picker-wrap">
    <div class="year-month">
      <span>{{ year }}年{{ month }}月</span>
    </div>
    <table>
      <thead>
        <tr>
          <th 
            v-for="(item, key) in daysLabel"
            :key="key"
          >{{ item }}</th>
        </tr>
      </thead>
      <tbody>
        <!-- 行数按处理过的周日所拥有的数组长度处理 -->
        <tr 
          v-for="(item, index) in daysMap[0]"
          :key="index"
        >
          <!-- 列数为当前列[周几]的第几个 -->
          <td 
            v-for="(item, key) in daysMap"
            :key="key"
            :class="{
              'is-disabled': isDisabledDate(daysMap[key][index]),
              'is-active': activeDate === daysMap[key][index]
            }"
          >
            <el-button
              v-show="daysMap[key][index]"
              :disabled="isDisabledDate(daysMap[key][index])"
              type="text"
              @click="dateChange(daysMap[key][index])"
            >
              {{daysMap[key][index]}}
            </el-button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="picker-footer margin-top24">
    <span class="margin-left24">
      <i class="icon-tip"></i>
      活动日
    </span>
    <span>
      <i class="icon-tip active-icon"></i>
      选定日期
    </span>
  </div>
</div>
</template>

<script>
export default {
  props: {
    year: {
      type: [String, Number],
      default: 1978
    },
    month: {
      type: [String, Number],
      default: 1
    },
    isDisabledDate: {
      type: Function,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      daysLabel: ['日', '一', '二', '三', '四', '五', '六'],
      activeDate: ''
    }
  },

  computed: {
    daysMap () {
      // 保存当月日期对应的周几 0对应周日 以此类推
      let dateMap = {
        0: [],
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
        6: []
      }


      const year = parseInt(this.year, 10) || 1978
      const month = parseInt(this.month, 10) || 1

      // 计算一个月有多少天
      let newDate = new Date(year, month, 0)
      let days = newDate.getDate()

      // 计算第一天是星期几
      const firstDay = (new Date(`${year}-${month}-${1}`).getDay())
      
      for (let j = 0; j < firstDay; j++) {
        dateMap[j].push(0)
      }
      dateMap[firstDay].push(1)

      // 获取这个月的每个日期对应的周期
      for (let i = 2; i <= days; i++) {
        const nowDay = new Date(`${year}-${month}-${i}`)
        dateMap[nowDay.getDay()].push(i)
      }

      return dateMap     
    }
  },
  methods: {
    clearDate () {
      this.activeDate = ''
      this.$emit('dateChange', this.activeDate)
    },
    dateChange (val) {
      // 如果选中的正是这个日期，则再次点击清空选项
      if (this.activeDate === val) {
        this.activeDate = ''
      } else {
        this.activeDate = val
      }

      this.$emit('dateChange', this.activeDate)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/dayPicker/dayPicker.vue